import {
    CREATE_LEAD_CLEAN,
    CLEAN_CREATE_LEAD_ERROR,
} from "_models/redux/types";

export const cleanCreateLead = () => async (dispatch) => {
    try {
        dispatch({
            type: CREATE_LEAD_CLEAN,
            payload: [],
        });
    } catch (e) {
        dispatch({
            type: CLEAN_CREATE_LEAD_ERROR,
            payload: [],
        });
    }
};
